import { cn } from "@strivelabs/ui-core"

export interface NavSectionLabelProps {
  label: string
  className?: string
}

/** Uppercase group heading such as WORK, INTELLIGENCE or CHANNELS. */
export function NavSectionLabel({ label, className }: NavSectionLabelProps) {
  return (
    <div
      className={cn(
        "px-2 pb-0.5 pt-2.5 text-v2-eyebrow font-medium uppercase text-v2-sidebar-foreground/60",
        className,
      )}
    >
      {label}
    </div>
  )
}
